import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { SharedUser } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<SharedUser>>>;

const getSharedUsers = (individualId: string): ReturnType => {
    return Request.get(`/individuals/${individualId}/users`);
};

export default getSharedUsers;
